export const FETCH_ORGANISATIONS = "fetch_organisations";
export const FETCH_SINGLE_ORGANISATION = "fetch_single_organisation";
export const ADD_CAMPAIGN = "add_campaign";
export const UPDATE_CAMPAIGN = "update_campaign";
export const UPDATE_ORGANISATION = "update_campaign_and_members";
export const DELETE_CAMPAIGN = "delete_campaign";
export const CREATE_GROUP = "create_group";
export const EDIT_GROUP = "edit_group";
export const DELETE_GROUP = "delete_group";
export const ADD_MEMBERS_TO_GROUP = "add_members_to_group";
export const REMOVE_MEMBERS_TO_GROUP = "remove_members_from_group";
export const FETCH_GROUPS = "fetch_groups";
export const ADJUST_REWARD_DISTRIBUTION = "adjust_reward_distribution";
export const SAVE_CURRENT_REWARD_DISTRIBUTION = "save_current_reward_distribution";
export const UPDATE_ORGANIZATION_SETTINGS = "update_organization_settings";